import React, { useEffect } from 'react';

import StampAccordion from './StampAccordion';
import HolidayAccordion from './HolidayAccordion';
import ApprovedTransferDomain from '../domain/approvedTransferDomain';
import ApprovedAllowanceDomain from '../domain/approvedAllowanceDomain';
import ApprovedStampDomain from '../domain/approvedStampDomain';
import ApprovedHolidayDomain from '../domain/approvedHolidayDomain';
import ApprovedOvertimeDomain from '../domain/approvedOvertimeDomain';
import ApprovedHolidayWorkDomain from '../domain/approvedHolidayWorkDomain';
import OvertimeAccordion from './OvertimeAccordion';
import HolidayWorkAccordion from './HolidayWorkAccordion';
import TransferAccordion from './TransferAccordion';
import AllowanceAccordion from './AllowanceAccordion';

const ApprovedTab: React.FC<{
  stampList: ApprovedStampDomain[];
  holidayList: ApprovedHolidayDomain[];
  overtimeList: ApprovedOvertimeDomain[];
  holidayWorkList: ApprovedHolidayWorkDomain[];
  transferList: ApprovedTransferDomain[];
  allowanceList: ApprovedAllowanceDomain[];
}> = ({
  stampList,
  holidayList,
  overtimeList,
  holidayWorkList,
  transferList,
  allowanceList,
}) => {
  useEffect(() => {
    console.log('ApprovedTab');
  }, [
    stampList,
    holidayList,
    overtimeList,
    holidayWorkList,
    transferList,
    allowanceList,
  ]);

  return (
    <div>
      <StampAccordion list={stampList} />

      <HolidayAccordion list={holidayList} />

      <OvertimeAccordion list={overtimeList} />

      <HolidayWorkAccordion list={holidayWorkList} />

      <TransferAccordion list={transferList} />

      <AllowanceAccordion list={allowanceList} />
    </div>
  );
};

export default ApprovedTab;
